import Vue from "vue";
import {
  Ajax as $Ajax,
  httpRequest as $HttpRequest,
  MD5 as $MD5,
  baseURL as $BaseURL,
  http as $Http,
} from "@/ajax";
import $RModal from "@/modal";
import $Cookies from "js-cookie";
import {
  dateFormat as $DateFormat,
  queryString as $QueryString,
} from "riku-verycloud";

const plugins = {
  install(Vue, options = {}) {
    Object.assign(Vue.prototype, {
      $Ajax,
      $HttpRequest,
      $MD5,
      $Cookies,
      $BaseURL,
      $Http,
      $RModal,
      $DateFormat,
      $QueryString,
    });
  },
};

import {
  Icon,
  Button,
  Popup,
  Tab,
  Tabs,
  Image as VanImage,
  PullRefresh,
  CountDown,
  Swipe,
  SwipeItem,
  Sku,
  AddressList,
  Cascader,
  Field,
  Cell,
  CellGroup,
  AddressEdit,
  Form,
  Radio,
  RadioGroup,
  Picker,
  Switch,
  Checkbox,
  CheckboxGroup,
  NavBar,
  Uploader as VanUploader,
  DatetimePicker,
  Rate,
  Toast,
  Stepper,
  Collapse,
  CollapseItem,
} from "vant";

Vue.use(Icon);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(VanImage);
Vue.use(PullRefresh);
Vue.use(CountDown);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Sku);
Vue.use(AddressList);
Vue.use(Cascader);
Vue.use(Field);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(AddressEdit);
Vue.use(Form);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Picker);
Vue.use(Switch);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(NavBar);
Vue.use(VanUploader);
Vue.use(DatetimePicker);
Vue.use(Rate);
Vue.use(Toast);
Vue.use(Stepper);
Vue.use(Collapse);
Vue.use(CollapseItem);

export default plugins;
